import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'windi.css'
import { vfmPlugin } from 'vue-final-modal'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

createApp(App)
  .use(store)
  .use(router)
  .use(vfmPlugin({
    key: '$vfm',
    componentName: 'VueFinalModal',
    dynamicContainerName: 'ModalsContainer'
  }))
  .use(VueSweetalert2)
  .component('v-select', vSelect)
  .mount('#app')
